'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Loading = require('components/Commons/Loading/Loading'),
    NavigationUtils = require('utils/NavigationUtils'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    get = require('lodash/object').get,
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    PurchaseOrderUtils = require('utils/PurchaseOrderUtils'),
    {map, find, filter} = require('lodash/collection'),
    {Navigation} = require('react-router'),
    ga = require('react-ga');

let VendorItemAdmin = React.createClass({displayName: "VendorItemAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedVendor: null,
            companyName: NavigationUtils.getQueryParam('companyName')
        };
    },

    componentDidMount() {
        this.fetchVendorItems();
        ga.pageview('/vendor-item-admin');
    },

    fetchVendorItems() {
        const self = this;
        const vendorId = NavigationUtils.getPathParam('vendors');
        InventoryStore.fetchVendorItems(vendorId, function (vendorItems) {
            InventoryStore.fetchAllItems(function (items) {
                const currencyInfo = NumberUtils.getCurrentCurrency();
                self.setState({
                    vendorItems: ContentUtils.filterEnable(self._decoratorVendorItems(vendorItems)),
                    items: ContentUtils.filterEnable(items),
                    currentCurrency: get(currencyInfo, 'symbol')
                });
            });
        });
    },

    _decoratorVendorItems(vendorItems) {
        return map(vendorItems, vendorItem => {
            vendorItem.code = get(vendorItem, 'supplierCode') ||  get(vendorItem, 'item.code');
            vendorItem.unit = get(vendorItem, 'supplierUnit') ||  get(vendorItem, 'item.unit');
            vendorItem.priceUnitDisplay = NumberUtils.formatCurrency(PurchaseOrderUtils.getPriceOfPurchaseItem(vendorItem), +get(SessionStore.getCurrentCurrencyDigits(), 'value')) + ' /' + get(vendorItem, 'unit');
            return vendorItem;
        });
    },

    _backToVendor() {
        this.transitionTo('/vendors');
    },

    _onDeleteVendorItem(itemId, onSuccess, onFailure) {
        const vendorId = NavigationUtils.getPathParam('vendors');
        InventoryStore.deleteVendorItem(vendorId, itemId, onSuccess, onFailure);
        this._clean();
    },

    _onChangeVendorItem(item, onSuccess, onFailure) {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const itemId = item.itemId;
        InventoryStore.changeVendorItem(vendorId, itemId, item, onSuccess, onFailure);
        this.setState(Object.assign(this.getInitialState(), {selectedItem: item}));
    },

    _onAddVendorItem(item, onSuccess, onFailure) {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const itemId = item.itemId;
        InventoryStore.addVendorItem(vendorId, itemId, item, onSuccess, onFailure);
        this._clean();
    },

    _onRowSelection(selectedItem,
                    itemIndex,
                    lastRowScrollPosition,
                    headerActiveFilters) {
        this.setState(
            {
                selectedItem,
                isEditMode: !!selectedItem,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset Y es outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this._clean();
    },

    _clean() {
        this.setState({
            preSelectedItem: null,
            selectedItem: null,
            selectedItemDropDown: null
        });
    },

    _getBreadcrumbLinks() {
        return [
            {link: 'vendors', displayName: t('vendor_admin_title_suppliers')},
            {displayName: get(this.state, 'companyName')}
        ];
    },

    _onChangeItem(evt, index, selectedItemDropdown) {
        const {items} = this.state;
        const selectedItem = find(items, item => get(selectedItemDropdown, 'itemModel.id') === get(item, 'id'));
        this.setState({
            selectedItemDropDown: selectedItem
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _onBlurSelectedItem(preSelectedVendorItem) {
        if (preSelectedVendorItem) {
            this.setState(prevState => {
                if (prevState.selectedItem) {
                    return {
                        preSelectedItem: Object.assign(
                            prevState.selectedItem,
                            preSelectedVendorItem
                        )
                    };
                } else {
                    return {
                        preSelectedItem: preSelectedVendorItem
                    };
                }
            });
        }
    },

    _goToContacts() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/contacts', {vendorId}, {companyName});
    },

    _goToAddress() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/addresses', {vendorId}, {companyName});
    },

    render() {
        let {items, vendorItems, selectedItem, currentCurrency} = this.state;
        if (!items) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('vendor_item_change_success_message'),
                changeFailureMessage: t('vendor_item_change_failure_message'),
                deleteSuccessMessage: t('vendor_item_delete_success_message'),
                addSuccessMessage: t('vendor_item_add_success_message'),
                addFailureMessage: t('vendor_item_add_failure_message')
            };
            const { preSelectedItem } = this.state;

            let relativeUnitAmountLabelDisplay;
            let unit;
            if (selectedItem) {
                unit= getUnitFromVendorItem(selectedItem);
                relativeUnitAmountLabelDisplay = `${t('label_amount')} (${get(selectedItem, 'item.unit')}) ${t('per')} (${ unit })`;
            } else {
                unit = get(preSelectedItem, 'supplierUnit') || get(preSelectedItem, 'unit');
                relativeUnitAmountLabelDisplay = `${t('label_amount')} ${String(unit) === 'undefined' ? '' : `(${unit})`} ${t('vendor_item_label_per_supplier_unit')}`;
            }
            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._backToVendor}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._backToVendor}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('vendor_admin_label_set_address'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._goToAddress}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('vendor_admin_address_set_contacts'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._goToContacts}
                    )
                }
            ];

            let contextHolder = this.getContextHolderInstance();

            const formFieldsEl = [
                React.createElement(FormGroupTextFieldSuggested, {
                    onBlur: this._onBlurSelectedItem, 
                    operationsHolder: contextHolder, 
                    isImmutable: true, 
                    items: items, 
                    isEditMode: !!(get(selectedItem, 'item') || preSelectedItem), 
                    itemsDisabled: filterItemsAlreadyInUse(items, vendorItems), 
                    readerAttribute: "description", 
                    readerAttributeValue: "id", 
                    writerAttribute: "itemId", 
                    name: t('item'), 
                    value: get(selectedItem, 'item') || preSelectedItem, 
                    onChange: this._onChangeItem, 
                    onEnter: this._onEnterPress, 
                    label: t('vendor_item_label_write_item_name')}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "supplierCode", 
                    name: t('vendor_item_label_supplier_code'), 
                    isRequired: false, 
                    value: selectedItem, 
                    isRelaxedText: true, 
                    decimalDigits: 4, 
                    onEnter: this._onEnterPress, 
                    label: t('vendor_item_label_supplier_code')}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "supplierUnit", 
                    isRequired: true, 
                    name: t('vendor_item_label_supplier_unit'), 
                    value: selectedItem, 
                    isRelaxedText: true, 
                    onEnter: this._onEnterPress, 
                    label: t('vendor_item_label_supplier_unit')}
                ),
               React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "priceUnit", 
                    isRequired: false, 
                    name: t('vendor_item_label_price'), 
                    value: selectedItem, 
                    isRelaxedText: true, 
                    decimalDigits: 4, 
                    isDecimalFormat: true, 
                    onEnter: this._onEnterPress, 
                    label: `${t('vendor_item_label_price')} (${currentCurrency}) ${t('vendor_item_label_per_supplier_unit')}`}
                ),
               React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "relativeUnitAmount", 
                    isRequired: false, 
                    name: relativeUnitAmountLabelDisplay, 
                    value:  selectedItem || '1', 
                    isRelaxedText: true, 
                    decimalDigits: 4, 
                    isDecimalFormat: true, 
                    onEnter: this._onEnterPress, 
                    label: relativeUnitAmountLabelDisplay}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "minimumOrder", 
                    isRequired: true, 
                    name: t('vendor_item_column_name_minimum_order'), 
                    value: selectedItem, 
                    onEnter: this._onEnterPress, 
                    label: `${t('vendor_item_column_name_minimum_order')}`}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "arrivalDays", 
                    isRequired: true, 
                    name: t('vendor_item_label_arrival_days'), 
                    value: selectedItem, 
                    label: t('vendor_item_label_arrival_days'), 
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "bp-vendor-items-view"}, 
                    React.createElement(AdminScaffolding, {
                        title: t('vendor_item_title_supplier_items'), 
                        moduleName: "ADMIN_VENDOR_ITEMS", 
                        messages: messages, 
                        onAddText: t('vendor_admin_label_associate'), 
                        onDeleteText: t('vendor_admin_label_disassociate'), 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems:  this.fetchVendorItems, 
                        headerFields: formFieldsEl, 
                        onAdd:  this._onAddVendorItem, 
                        onChange:  this._onChangeVendorItem, 
                        onCancel:  this._onCancel, 
                        onDelete:  this._onDeleteVendorItem, 
                        addEnterKeyDown: this._addEnterKeyDown, 
                        additionalButtons: additionalButtons, 
                        breadcrumb: this._getBreadcrumbLinks()
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            onRowSelection:  this._onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['priceUnit'], 
                            filteredColumns: ['code', 'unit', 'item.description', 'priceUnitDisplay', 'relativeUnitAmount', 'minimumOrder', 'arrivalDays'], 
                            columnNames: [
                                t('vendor_item_label_supplier_code'),
                                t('vendor_item_label_supplier_unit'),
                                t('item'),
                                t('vendor_item_column_name_price_per_unit'),
                                t('vendor_item_column_name_relative_unit_amount'),
                                t('vendor_item_column_name_minimum_order'),
                                t('vendor_item_label_arrival_day'),
                                t('vendor_item_column_name_preferred')], 
                            displayAttributes: ['code', 'unit', 'item.description', 'priceUnitDisplay', 'relativeUnitAmount', 'minimumOrder', 'arrivalDays']
                        }, 
                            vendorItems 
                        )
                    )
                )
            );
        }
    }
});

function filterItemsAlreadyInUse(items, vendorItems) {
    const itemIdsAlreadyInUse = map(vendorItems, vendorItem => get(vendorItem, 'item.id')) || [];
    const itemsFiltered = filter(items, item => itemIdsAlreadyInUse.includes(get(item, 'id')));
    const itemsMarked = map(itemsFiltered, item => {
        item.isDisabled = true;
        return item;
    });

    return itemsMarked;
}

function getUnitFromVendorItem(vendorItem) {
    return get(vendorItem, 'supplierUnit') ||  get(vendorItem, 'item.unit');
}

module.exports = VendorItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorAdmin/VendorItemsAdmin.js
 **/